export default __webpack_public_path__ + "ab594ade6e3161fd8fe74946485f5f2d.png";